<nav class="navbar navbar-expand-lg navbar-light header-navbar bg-white comman-shadow" [ngClass]="{'navbar-brand-center': menuPosition === 'Top', 'navbar-static': menuPosition === 'Side' &&
  config?.layout.navbar.type === 'Static' , 'navbar-sticky': menuPosition === 'Side' &&
  config?.layout.navbar.type === 'Fixed', 'fixed-top': isSmallScreen && menuPosition === 'Top'}">
  <div class="container-fluid navbar-wrapper">
    <!-- responsive menubar -->
    <div class="navbar-toggle menu-toggle d-xl-none d-block float-left align-items-center justify-content-center"
      data-toggle="collapse" (click)="toggleSidebar()">
      <i class="ft-menu font-medium-3"></i>
    </div>

    <div class="navbar-header d-flex">
      <h4 class="navbar-title">{{getpageTitleName()}}</h4>
    </div>
    <div class="navbar-container">
      <div class="collapse navbar-collapse d-block" id="navbarSupportedContent">
        <ul class="navbar-nav">
          <li class="role-dropdown mr-2 d-none d-md-flex" *ngIf="logginedUser && isActivatedUser">
            <div class="role-switcher" #roleSwitcher [class.open]="isRoleDropdownOpen">
              <button class="role-trigger" type="button" (click)="toggleRoleDropdown($event)"
                [attr.aria-expanded]="isRoleDropdownOpen" aria-haspopup="listbox">
                <span class="role-trigger-icon">
                  <i [ngClass]="getRoleIconClass(getCurrentRoleId())"></i>
                </span>
                <span class="role-trigger-text">{{ getCurrentRoleLabel() }}</span>
                                <span class="role-chevron" aria-hidden="true">
                  <i class="ft-chevron-down"></i>
                </span>
              </button>

              <div class="role-menu" *ngIf="isRoleDropdownOpen" role="listbox">
                <button
                  class="role-menu-item"
                  *ngFor="let roleId of logginedUser?.roleIds || []"
                  [class.active]="roleId === getCurrentRoleId()"
                  type="button"
                  (click)="selectRole(roleId)">
                  <span class="role-icon" [ngClass]="getRoleToneClass(roleId)">
                    <i [ngClass]="getRoleIconClass(roleId)"></i>
                  </span>
                  <span class="role-menu-label">{{ roleId | role }}</span>
                </button>
              </div>
            </div>
          </li>
          <li class="dropdown nav-item" placement="bottom-left" display="static" ngbDropdown>
            <a class="nav-link dropdown-toggle user-dropdown d-flex align-items-center p-0" id="dropdownBasic2"
              href="javascript:;" data-toggle="dropdown" ngbDropdownToggle>
              <div class="user d-md-flex d-none"
                style="flex-direction: column; align-items: flex-end; line-height: 1.1;">
                <span class="text-right nav-profile-title">{{logginedUser.currentRoleId | role}}</span>
                <span class="text-right font-small-3 nav-profile-admin">
                  {{ logginedUser?.email || '' }}
                </span>
              </div>
              <div class="avatar ml-2 nav-avatar" aria-hidden="true">
                <img
                  [src]="avatarSrc"
                  (error)="onAvatarError()"
                  alt="avatar"
                  height="36"
                  width="36"
                  class="nav-avatar__img" />
              </div>
            </a>
            <div class="dropdown-menu nav-profile-menu text-left dropdown-menu-right m-0" aria-labelledby="dropdownBasic2"
              ngbDropdownMenu>
              <a class="dropdown-item" routerLink="/chat">
                <div class="nav-profile-menu__item">
                  <span class="nav-profile-menu__icon"><i class="ft-message-square"></i></span>
                  <span>Chat</span>
                </div>
              </a>
              <a class="dropdown-item" routerLink="/profile">
                <div class="nav-profile-menu__item">
                  <span class="nav-profile-menu__icon"><i class="ft-edit"></i></span>
                  <span>Edit Profile</span>
                </div>
              </a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item nav-profile-menu__logout" (click)="logout()">
                <div class="nav-profile-menu__item">
                  <span class="nav-profile-menu__icon"><i class="ft-power"></i></span>
                  <span>Logout</span>
                </div>
              </a>
            </div>
          </li>
          <!-- <li class="nav-item d-none d-lg-block mr-2 mt-1">
            <a class="nav-link notification-sidebar-toggle" (click)="toggleNotificationSidebar();"><i
                class="ft-align-right font-medium-3"></i></a>
          </li> -->
        </ul>
      </div>
    </div>
  </div>
</nav>

